<script lang="ts">
    import { service } from "@frontend/services";
    import type { ApiResultOfGameServerDTO, AuthenticatedRequestOfEditGameServerDTO, EditGameServerDTO, GameServerDTO } from "@frontend/walletapi";
    import { translate, currentLanguage } from "../Translator";
    
    export let server: GameServerDTO;
    export let dismiss: () => void;
    
    let result: ApiResultOfGameServerDTO | undefined = undefined;
    let editServer: EditGameServerDTO = {
        Id: server.Id,
        Label: server.Label,
        User: server.User,
        Password: server.Password,
        Endpoint: server.Endpoint
    };

    async function EditServer() {
        const editServerRequest: AuthenticatedRequestOfEditGameServerDTO = {
            Token: sessionStorage.token,
            Data: editServer
        };

        try {
            result = await service.walletapi.editGameServer(editServerRequest);
            
            if (result.Success) {
                console.log("Server updated successfully:", result.Data);
                dismiss();
            } else {
                console.error("Error updating server:", result.ErrorMessage);
            }
        } catch (error) {
            console.error("Error updating server:", error);
        }
    }
</script>

<h2 class="ui centered dividing header">{$translate('Edit Game Server')}</h2>

{#if result && !result.Success}
    <div class="ui negative message">
        <div class="header">Error</div>
        <p>{result.ErrorMessage ?? "Unknown error when updating server"}</p>
    </div>
{/if}

<form class="ui form" on:submit|preventDefault={EditServer}>
    <div class="field">
        <label for="">{$translate('Label')}</label>
        <input 
            type="text"
            bind:value={editServer.Label}
            placeholder="Enter server label"
            required
        >
    </div>

    <div class="field">
        <label for="">{$translate('Username')}</label>
        <input 
            type="text"
            bind:value={editServer.User}
            placeholder="Enter username"
            required
        >
    </div>

    <div class="field">
        <label for="">{$translate('Password')}</label>
        <input 
            type="text"
            bind:value={editServer.Password}
            placeholder="Enter password"
            required
        >
    </div>

    <div class="field">
        <label for="">{$translate('Endpoint')}</label>
        <input 
            type="text"
            bind:value={editServer.Endpoint}
            placeholder="Enter server endpoint (IP or URL)"
            required
        >
    </div>

    <div class="two fields" style="display: flex">
        <button class="ui negative fluid button" type="button" on:click={dismiss}>{$translate('Cancel')}</button>
        <button class="ui positive fluid button" type="submit">{$translate('Update Server')}</button>
    </div>
</form>
